export default __webpack_public_path__ + "static/media/Foxtail-Lily_L3.e283eadd.png";